import { ChangeDetectionStrategy, Component, Input, OnInit, signal, ViewEncapsulation } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { Bind } from "../../decorators/bind.decorator";
import { Item } from "../../pojo/Item";
import { S25Util } from "../../util/s25-util";
import { ContactService } from "../../services/contact.service";

@TypeManagerDecorator("s25-ng-object-details-comments")
@Component({
    selector: "s25-ng-object-details-comments",
    template: `
        @if (init) {
            @if (!comments && !canEdit) {
                none
            } @else {
                <div [class.fade-preview-container]="fadePreview()" (click)="fadePreview.set(!fadePreview())">
                    <s25-ng-editable-richtext
                        [(val)]="comments"
                        [readOnly]="!canEdit"
                        [autoResize]="fadePreview()"
                        [fadePreview]="fadePreview()"
                        [hasCommit]="true"
                        [onCommit]="save"
                    ></s25-ng-editable-richtext>
                </div>
            }
        }
    `,
    styles: `
        :host {
            display: block;
            padding: 1rem;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false,
})
export class S25ObjectDetailsCommentsComponent implements OnInit {
    @Input({ required: true }) itemId: number;
    @Input({ required: true }) itemTypeId: number;
    @Input({ required: true }) comments: string;
    @Input({ required: true }) canEdit: boolean;

    fadePreview = signal(false);
    init = signal(false);

    ngOnInit() {
        this.fadePreview.set(this.comments?.length > 350);
        this.init.set(true);
    }

    @Bind
    async save() {
        let error;
        switch (this.itemTypeId) {
            case Item.Ids.Contact:
                const [_, e] = await S25Util.Maybe(
                    ContactService.putContactMinimal(this.itemId, { comments: this.comments }),
                );
                if (e) error = e;
        }
        if (error) return S25Util.showError(error);
    }
}
